import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { EnvelopeIcon, MagnifyingGlassIcon } from '@heroicons/react/24/outline';

const MeetTheStaff = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedDepartment, setSelectedDepartment] = useState('All');

  const staffData = [
    // Leadership
    { firstName: 'Jennifer', lastName: 'Tegano', title: 'Principal', email: 'JTegano@schools.nyc.gov', department: 'Leadership' },
    { prefix: 'Dr.', firstName: 'Nadine', lastName: 'Sinclair', title: 'Assistant Principal', email: 'NSinclair@schools.nyc.gov', department: 'Leadership' },

    // Administration
    { firstName: 'Yesenia', lastName: 'Rosario', title: 'School Secretary', email: 'YRosario6@schools.nyc.gov', department: 'Administration' },
    { firstName: 'Judith', lastName: 'Diaz', title: 'Pupil Accounting', email: 'JDiaz41@schools.nyc.gov', department: 'Administration' },
    { firstName: 'Margarete', lastName: 'Simanca', title: 'SBST Secretary', email: 'MSimanca@schools.nyc.gov', department: 'Administration' },
    { firstName: 'Destynee', lastName: 'Arnold', title: 'Community School Director', email: 'DArnold7@schools.nyc.gov', department: 'Administration' },

    // 3K Teachers
    { firstName: 'Xiomara', lastName: 'Sandoval', title: '3K Teacher', email: 'XSandoval@schools.nyc.gov', department: 'Early Childhood' },
    { firstName: 'Rebecca', lastName: 'Zalouk', title: '3K Teacher', email: 'RZalouk@schools.nyc.gov', department: 'Early Childhood' },

    // PreK Teachers
    { firstName: 'Michelle', lastName: 'Breier', title: 'PreK Teacher', email: 'MBreier2@schools.nyc.gov', department: 'Early Childhood' },
    { firstName: 'Yesenia', lastName: 'Rojas', title: 'PreK Teacher', email: 'YRojas3@schools.nyc.gov', department: 'Early Childhood' },

    // Kindergarten Teachers
    { firstName: 'Joanne', lastName: 'Lyons', title: 'Kindergarten Teacher', email: 'JLyons5@schools.nyc.gov', department: 'Elementary' },
    { firstName: 'Madeline', lastName: 'Salazar', title: 'Kindergarten Teacher', email: 'MSalazar6@schools.nyc.gov', department: 'Elementary' },

    // 1st Grade Teachers
    { firstName: 'Alyssa', lastName: 'Cohen', title: '1st Grade Teacher', email: 'ACohen55@schools.nyc.gov', department: 'Elementary' },
    { firstName: 'Jennifer', lastName: 'Galante', title: '1st Grade Teacher', email: 'JVacchio2@schools.nyc.gov', department: 'Elementary' },

    // 2nd Grade Teachers
    { firstName: 'Joanna', lastName: 'Aquino', title: '2nd Grade Teacher', email: 'JAquino22@schools.nyc.gov', department: 'Elementary' },
    { firstName: 'Ivonne', lastName: 'Luna', title: '2nd Grade Teacher', email: 'ILuna2@schools.nyc.gov', department: 'Elementary' },
    { firstName: 'Latrelle', lastName: 'Prude', title: '2nd Grade Teacher', email: 'LPrude2@schools.nyc.gov', department: 'Elementary' },

    // 3rd Grade Teachers
    { firstName: 'Kiara', lastName: 'Fernandez', title: '3rd Grade Teacher', email: 'KFernandez33@schools.nyc.gov', department: 'Elementary' },
    { firstName: 'Danielle', lastName: 'Pryor', title: '3rd Grade Teacher', email: 'DPryor4@schools.nyc.gov', department: 'Elementary' },
    { firstName: 'Eunice', lastName: 'Son', title: '3rd Grade Teacher', email: 'ESon2@schools.nyc.gov', department: 'Elementary' },

    // 4th Grade Teachers
    { firstName: 'Joanna', lastName: 'Lore', title: '4th Grade Teacher', email: 'JLore2@schools.nyc.gov', department: 'Elementary' },
    { firstName: 'Brent', lastName: 'Nycz', title: '4th Grade Teacher', email: 'BNycz@schools.nyc.gov', department: 'Elementary' },
    { firstName: 'Taryn', lastName: 'Wahlis', title: '4th Grade Teacher', email: 'TWahlis@schools.nyc.gov', department: 'Elementary' },

    // 5th Grade Teachers
    { firstName: 'Myfanwi', lastName: 'Meyrick', title: '5th Grade Teacher', email: 'MMeyrick@schools.nyc.gov', department: 'Elementary' },
    { firstName: 'Tricia', lastName: 'Piskopus', title: '5th Grade Teacher', email: 'TPiskopus@schools.nyc.gov', department: 'Elementary' },
    { firstName: 'Annelise', lastName: 'Schriber', title: '5th Grade Teacher', email: 'ASchriber@schools.nyc.gov', department: 'Elementary' },

    // Middle School Teachers
    { firstName: 'Jayson', lastName: 'Acosta', title: 'Middle School Social Studies', email: 'JAcosta2@schools.nyc.gov', department: 'Middle School' },
    { firstName: 'Kennedy', lastName: 'Douglas', title: 'Middle School Science/SS Teacher', email: 'kennedy.jdouglas@gmail.com', department: 'Middle School' },
    { firstName: 'Jennifer', lastName: 'Glick', title: 'Middle School SS and ELA Teacher', email: 'JGlick2@schools.nyc.gov', department: 'Middle School' },
    { firstName: 'Christina', lastName: 'Ilutiza', title: 'Middle School STEAM', email: 'CIlutiza@schools.nyc.gov', department: 'Middle School' },
    { firstName: 'Sunny', lastName: 'Kam', title: 'Middle School Science Teacher', email: 'SKam@schools.nyc.gov', department: 'Middle School' },
    { firstName: 'John', lastName: 'Kim', title: 'Middle School Math Teacher', email: 'JKim61@schools.nyc.gov', department: 'Middle School' },
    { firstName: 'Jennifer', lastName: 'Lavalle', title: 'Middle School ELA Teacher', email: 'JLavalle@schools.nyc.gov', department: 'Middle School' },
    { firstName: 'Nyesha', lastName: 'Patterson-Blain', title: 'Middle School Science Teacher', email: 'NPattersonBlain@schools.nyc.gov', department: 'Middle School' },
    { firstName: 'Madeline', lastName: 'Santoro', title: 'Middle School SS/ELA Teacher', email: 'MSantoro7@schools.nyc.gov', department: 'Middle School' },
    { firstName: 'Alyssa', lastName: 'Somoano', title: 'Middle School ELA Teacher', email: 'ASomoano@schools.nyc.gov', department: 'Middle School' },
    { firstName: 'Michelle', lastName: 'Velazquez', title: 'Middle School SS/ELA Teacher', email: 'MVelazq3@schools.nyc.gov', department: 'Middle School' },
    { firstName: 'Chantyll', lastName: 'Williams', title: 'Middle School Science/SS Teacher', email: 'CWilliams199@schools.nyc.gov', department: 'Middle School' },
    { firstName: 'Patrick', lastName: 'Yee', title: 'Middle School Math Teacher', email: 'PYee3@schools.nyc.gov', department: 'Middle School' },

    // Specialist Teachers
    { firstName: 'Tyrone', lastName: 'Alomia', title: 'Physical Education', email: 'TAlomia2@schools.nyc.gov', department: 'Specialists' },
    { firstName: 'Kendra', lastName: 'Brown', title: 'Art Teacher', email: 'KBrown22@schools.nyc.gov', department: 'Specialists' },
    { firstName: 'Arabella', lastName: 'Cintron', title: 'Theater Teacher', email: 'ACintro@schools.nyc.gov', department: 'Specialists' },
    { firstName: 'Elvira', lastName: 'Roman', title: 'Math Teacher Grades 6 & 7', email: 'ERoman3@schools.nyc.gov', department: 'Specialists' },
    { firstName: 'Amanda', lastName: 'Walsh', title: 'Science Teacher Grades 3-5', email: 'AWalsh8@schools.nyc.gov', department: 'Specialists' },

    // ENL Teachers
    { firstName: 'Lea', lastName: 'Quezada', title: 'ENL Teacher Grades 5-8', email: 'LQuezada5@schools.nyc.gov', department: 'Specialists' },
    { firstName: 'Jessica', lastName: 'Wacholder', title: 'ENL Teacher Grades 1-7', email: 'JWacholder@schools.nyc.gov', department: 'Specialists' },

    // Support Staff
    { firstName: 'Claudia', lastName: 'Belloso', title: 'Guidance Counselor', email: 'CBelloso@schools.nyc.gov', department: 'Support Services' },
    { firstName: 'Marc', lastName: 'Gerber', title: 'School Psychologist', email: 'MGerber3@schools.nyc.gov', department: 'Support Services' },
    { firstName: 'Nadiushka', lastName: 'Moquette', title: 'Bilingual School Psychologist', email: 'NMoquete@schools.nyc.gov', department: 'Support Services' },
    { firstName: 'Arianna', lastName: 'Colon', title: 'Mt. Sinai Social Worker', email: 'AColon64@schools.nyc.gov', department: 'Support Services' },
    { firstName: 'Daisy', lastName: 'Laureano', title: 'School Social Worker', email: 'DLaureano@schools.nyc.gov', department: 'Support Services' },
    { firstName: 'Jaclyn', lastName: 'Legacy', title: 'Speech Provider', email: 'JLegacy@schools.nyc.gov', department: 'Support Services' },
    { firstName: 'Kaylene', lastName: 'Ris', title: 'Speech Therapist', email: 'KRis2@schools.nyc.gov', department: 'Support Services' },
    { firstName: 'Daniel', lastName: 'Roth', title: 'Physical Therapist', email: 'DRoth6@schools.nyc.gov', department: 'Support Services' },
    { firstName: 'Angela', lastName: 'Tornatore', title: 'School Nurse Practitioner', email: 'ATornatore2@schools.nyc.gov', department: 'Support Services' },
    { firstName: 'Myra', lastName: 'Sanchez', title: 'School Nurse Assistant', email: 'MSanchez110@schools.nyc.gov', department: 'Support Services' },
    { firstName: 'Ivette', lastName: 'Jimenez', title: 'IEP Liaison', email: 'IJimenez2@schools.nyc.gov', department: 'Support Services' },
    { firstName: 'Reginald', lastName: 'Lamarre', title: 'Dean of Culture/BRT Leader', email: 'RLamarr@schools.nyc.gov', department: 'Support Services' },
    { firstName: 'Abigail', lastName: 'Medina', title: 'BRT Support Teacher', email: 'AMedina5@schools.nyc.gov', department: 'Support Services' },

    // Paraprofessionals
    { firstName: 'Magaly', lastName: 'Aguilar', title: 'Education Paraprofessional', email: 'MAguilar5@schools.nyc.gov', department: 'Paraprofessionals' },
    { firstName: 'Glenn', lastName: 'Bryant', title: 'Education Paraprofessional', email: 'GBryant10@schools.nyc.gov', department: 'Paraprofessionals' },
    { firstName: 'Malek', lastName: 'Burns', title: 'Education Paraprofessional', email: 'MBurns13@schools.nyc.gov', department: 'Paraprofessionals' },
    { firstName: 'Enid', lastName: 'Cruz', title: 'Education Paraprofessional', email: 'ECruz45@schools.nyc.gov', department: 'Paraprofessionals' },
    { firstName: 'Ebony', lastName: 'Keith', title: 'Education Paraprofessional', email: 'EKeith3@schools.nyc.gov', department: 'Paraprofessionals' },
    { firstName: 'Tanya', lastName: 'Moales', title: 'Education Paraprofessional', email: 'TMoales@schools.nyc.gov', department: 'Paraprofessionals' },
    { firstName: 'Amanda', lastName: 'Pelaez', title: 'Education Paraprofessional', email: 'APelaez5@schools.nyc.gov', department: 'Paraprofessionals' },
    { firstName: 'Christopher', lastName: 'Rodriguez', title: 'Education Paraprofessional', email: 'CRodriguez197@schools.nyc.gov', department: 'Paraprofessionals' },
    { firstName: 'Sujeil', lastName: 'Rodriguez', title: 'Education Paraprofessional', email: 'SRodriguez143@schools.nyc.gov', department: 'Paraprofessionals' },
    { firstName: 'Yeidy', lastName: 'Rodriguez', title: 'Education Paraprofessional', email: 'YRodriguez18@schools.nyc.gov', department: 'Paraprofessionals' },
    { firstName: 'Vivian', lastName: 'Sanchez', title: 'Education Paraprofessional', email: 'VSanchez6@schools.nyc.gov', department: 'Paraprofessionals' },
    { firstName: 'Luisa', lastName: 'Santiago', title: 'Education Paraprofessional', email: 'LSantiago24@schools.nyc.gov', department: 'Paraprofessionals' },
    { firstName: 'Sandy', lastName: 'Soto', title: 'Education Paraprofessional', email: 'SSoto30@schools.nyc.gov', department: 'Paraprofessionals' },
    { firstName: 'Delores', lastName: 'Vaughan', title: 'Educational Paraprofessional', email: 'DVaughan@schools.nyc.gov', department: 'Paraprofessionals' },
    { firstName: 'Dahsia', lastName: 'Williams', title: 'Educational Paraprofessional', email: 'DWilliams152@schools.nyc.gov', department: 'Paraprofessionals' },

    // School Aides
    { firstName: 'Kayla', lastName: 'Batiz', title: 'School Aide', email: 'KBatiz@schools.nyc.gov', department: 'School Aides' },
    { firstName: 'Mariah', lastName: 'Britton', title: 'School Aide', email: 'ABritton6@schools.nyc.gov', department: 'School Aides' },
    { firstName: 'Tanisha', lastName: 'Collins', title: 'School Aide', email: 'TCollins2@schools.nyc.gov', department: 'School Aides' },

    // After School Programs
    { firstName: 'Jarrett', lastName: 'Boddie', title: 'DYCD After School Supervisor', email: 'JBoddie@schools.nyc.gov', department: 'After School' },
    { firstName: 'Nirvana', lastName: 'Shaw', title: 'DYCD Director Union Settlement', email: 'NShaw2@schools.nyc.gov', department: 'After School' },
    { firstName: 'Assane', lastName: 'Sangare', title: 'Asphalt Green Coach', email: 'ASangare@schools.nyc.gov', department: 'After School' },

    // Substitute Teachers
    { firstName: 'Marie', lastName: 'Davis', title: 'Substitute Teacher', email: 'MDavis106@schools.nyc.gov', department: 'Substitute Staff' },
    { firstName: 'Raquel', lastName: 'Yehudah', title: 'Substitute Teacher', email: 'RYehuda@schools.nyc.gov', department: 'Substitute Staff' },
  ];

  const departments = [
    'All',
    'Leadership',
    'Administration',
    'Early Childhood',
    'Elementary',
    'Middle School',
    'Specialists',
    'Support Services',
    'Paraprofessionals',
    'School Aides',
    'After School',
    'Substitute Staff'
  ];

  const filteredStaff = staffData.filter(staff => {
    const matchesDepartment = selectedDepartment === 'All' || staff.department === selectedDepartment;
    const matchesSearch =
      staff.firstName.toLowerCase().includes(searchQuery.toLowerCase()) ||
      staff.lastName.toLowerCase().includes(searchQuery.toLowerCase()) ||
      staff.title.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesDepartment && matchesSearch;
  });

  return (
    <>
      <Navbar />
      <main id="main-content" className="bg-white">

      {/* Hero Section */}
      <section className="pt-24 md:pt-32 pb-16 md:pb-20 band-light text-brand-text-primary relative overflow-hidden">
        {/* Background decorative elements — decorative only, and not a
            full-bleed box so it can't visually overlap the hero text. */}
        <div aria-hidden="true" className="opacity-10">
          <div className="absolute top-10 left-10 w-32 h-32 border-2 border-brand-yellow rounded-full"></div>
          <div className="absolute bottom-10 right-10 w-40 h-40 border-2 border-brand-navy rounded-full"></div>
          <div className="absolute top-1/2 left-1/3 w-24 h-24 bg-brand-yellow/20 rounded-full"></div>
        </div>

        <div className="content-container relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <span className="inline-block bg-white shadow-sm text-brand-text-primary px-6 py-3 text-sm font-medium tracking-wider mb-8 border border-brand-yellow/50">
              Our Team
            </span>
            <h1 className="text-display font-display mb-8 relative">
              <span className="relative">
                Meet The Staff
                <div className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-24 h-1 bg-gradient-to-r from-brand-navy via-brand-yellow to-brand-navy"></div>
              </span>
            </h1>
            <p className="text-xl leading-relaxed max-w-3xl mx-auto">
              Dedicated educators and staff committed to nurturing the authors of tomorrow
            </p>
          </div>
        </div>
      </section>

      {/* Filter and Search Section */}
      <section className="py-12 bg-gray-50 border-b border-gray-200">
        <div className="content-container">
          <div className="max-w-6xl mx-auto">
            {/* Search Bar */}
            <div className="mb-8">
              <div className="relative">
                <input
                  type="text"
                  placeholder="Search by name or title..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  aria-label="Search staff by name or title"
                  className="w-full px-6 py-4 pl-12 border-2 border-gray-300 rounded-lg focus:outline-none focus:border-brand-navy transition-colors text-lg"
                />
                <MagnifyingGlassIcon className="absolute left-4 top-1/2 transform -translate-y-1/2 w-6 h-6 text-gray-400" />
              </div>
            </div>

            {/* Department Filter */}
            <div className="flex flex-wrap gap-2 justify-center">
              {departments.map((dept) => (
                <button
                  key={dept}
                  onClick={() => setSelectedDepartment(dept)}
                  className={`px-4 py-2 rounded-full font-medium transition-all duration-300 ${
                    selectedDepartment === dept
                      ? 'bg-brand-navy text-white shadow-lg border-2 border-brand-yellow'
                      : 'bg-white text-gray-700 hover:bg-brand-yellow/20 hover:border-brand-navy/20 border-2 border-gray-200'
                  }`}
                >
                  {dept}
                </button>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Staff Directory */}
      <section className="section-padding bg-white">
        <div className="content-container">
          <div className="max-w-7xl mx-auto">
            <h2 className="sr-only">Staff Directory</h2>
            {filteredStaff.length > 0 ? (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {filteredStaff.map((staff, index) => (
                  <div
                    key={index}
                    className="bg-white border-2 border-gray-100 rounded-lg p-6 hover:shadow-lg hover:border-brand-navy/30 transition-all duration-300 group"
                  >
                    {/* Staff Member Initial Circle */}
                    <div className="flex items-start space-x-4">
                      <div className="flex-shrink-0">
                        <div className="w-16 h-16 bg-brand-primary rounded-full flex items-center justify-center text-white font-display text-xl group-hover:bg-brand-accent-dark transition-all duration-300">
                          {staff.firstName.charAt(0)}{staff.lastName.charAt(0)}
                        </div>
                      </div>

                      <div className="flex-1 min-w-0">
                        <h3 className="text-lg font-display text-heading mb-1 group-hover:text-brand-navy transition-colors">
                          {staff.prefix ? `${staff.prefix} ` : ''}{staff.firstName} {staff.lastName}
                        </h3>
                        <p className="text-sm text-brand-text-muted mb-3 leading-relaxed">
                          {staff.title}
                        </p>
                        <a
                          href={`mailto:${staff.email}`}
                          className="inline-flex items-center text-sm text-brand-navy hover:text-brand-yellow transition-colors group/email"
                        >
                          <EnvelopeIcon className="w-4 h-4 mr-2 group-hover/email:scale-110 transition-transform" />
                          <span className="truncate">{staff.email}</span>
                        </a>
                      </div>
                    </div>

                    {/* Department Badge */}
                    <div className="mt-4 pt-4 border-t border-gray-100">
                      <span className="inline-block px-3 py-1 bg-brand-navy/5 text-brand-navy text-xs font-medium rounded-full">
                        {staff.department}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-center py-16">
                <p className="text-xl text-gray-500">No staff members found matching your search.</p>
              </div>
            )}
          </div>
        </div>
      </section>

      </main>
      <Footer />
    </>
  );
};

export default MeetTheStaff;
